import React, { lazy } from 'react';
import { FlameIcon } from 'lucide-react';
import { OfferBox } from './OfferBox';
import { UrgencyBadges } from './UrgencyBadges';
import { CTAButton } from './CTAButton';
import { SecurityBadges } from './SecurityBadges';
import { useCountdown } from '../hooks/useCountdown';
import { useGeoPricing } from '../hooks/useGeoPricing';
const productImg = 'https://cdn.magicpatterns.com/uploads/dW4XRABM1XSGsv1ffV6Su1/Gemini_Generated_Image_m1gog3m1gog3m1go.jpg';
const placeholderImg = 'https://digitalearnpro.com/wp-content/uploads/2025/09/20250930_1424_Espacio-para-tu-Imagen_simple_compose_01k6dtcpvgec9s48a98jsekbnr.png';
export function PurchaseSection() {
  const {
    minutes,
    seconds
  } = useCountdown(15 * 60);
  const {
    pricing
  } = useGeoPricing();
  return <section id="comprar" className="pt-0 pb-[20px] px-[15px] relative" data-id="element-187">
      <div className="max-w-[500px] mx-auto px-[15px]" data-id="element-188">
        <div className="my-5 mx-auto overflow-hidden shadow-[0_8px_20px_rgba(0,0,0,0.08)] rounded-lg relative max-w-full" data-id="element-189">
          <img loading="lazy" alt="Recetario Digital - Accede desde tu móvil o tablet" src={productImg} className="w-full h-auto block rounded-lg" data-id="element-190" />
        </div>

        <div className="text-center my-[25px] mx-auto mb-[15px]" data-id="element-191">
          <p className="text-[11px] font-semibold text-gray tracking-[1px] uppercase mb-2" data-id="element-192">
            +5.820 DESCARGAS
          </p>
          <h1 className="text-[18px] font-bold leading-[1.4] text-black" data-id="element-193">
            📦 Pack de Recetas Personalizadas + 5 Bonus Exclusivos 🎁
          </h1>
        </div>

        <OfferBox data-id="element-194" />

        {/* Enhanced Warning Box */}
        <div className="bg-gradient-to-br from-[rgba(30,30,30,0.8)] to-[rgba(10,10,10,0.9)] border border-primary-dark backdrop-blur-[5px] rounded-xl p-5 my-6 mx-auto text-center shadow-[0_0_20px_rgba(76,175,80,0.4)] relative overflow-hidden" data-id="element-195">
          <h3 className="text-primary-light text-[22px] mb-3 flex items-center justify-center gap-2.5 text-shadow-[0_0_10px_rgba(76,175,80,0.3)]" data-id="element-196">
            <FlameIcon size={22} className="text-primary-light" data-id="element-197" />
            ¡OFERTA SOLO POR HOY!
          </h3>
          <p className="text-[14px] text-white/80 leading-[1.5] mb-[20px]" data-id="element-198">
            Accede a <strong data-id="element-199">50 recetas personalizadas</strong> más{' '}
            <strong data-id="element-200">5 bonus exclusivos</strong>. ¡No pierdas esta oportunidad!
          </p>

          <div className="text-[13px] text-white/70 mb-2" data-id="element-201">
            La oferta termina en:
          </div>

          <div className="flex justify-center gap-3 text-center mb-[20px]" data-id="element-202">
            <div className="bg-black/40 p-3 rounded-lg min-w-[65px]" data-id="element-203">
              <div className="text-[30px] font-bold text-white leading-none" data-id="element-204">
                {minutes.toString().padStart(2, '0')}
              </div>
              <div className="text-[10px] uppercase text-white/70 mt-2 tracking-[0.5px]" data-id="element-205">
                Min
              </div>
            </div>
            <div className="bg-black/40 p-3 rounded-lg min-w-[65px]" data-id="element-206">
              <div className="text-[30px] font-bold text-white leading-none" data-id="element-207">
                {seconds.toString().padStart(2, '0')}
              </div>
              <div className="text-[10px] uppercase text-white/70 mt-2 tracking-[0.5px]" data-id="element-208">
                Seg
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-primary to-primary-light text-white py-2 px-5 rounded-full font-bold text-[16px] uppercase inline-block shadow-[0_4px_10px_rgba(76,175,80,0.25)]" data-id="element-209">
            {pricing.savings}
          </div>
        </div>

        <UrgencyBadges data-id="element-210" />

        <CTAButton href="https://kleoyshop.com/cart/add?id=52708878745928&quantity=1" className="mt-6 mb-2" data-id="element-211">
          ¡SÍ, QUIERO MI PACK AHORA!
        </CTAButton>

        <SecurityBadges data-id="element-212" />

        {/* Guarantee Box */}
        <div className="flex items-center justify-center gap-4 bg-white rounded-lg p-4 my-6 mx-auto shadow-[0_4px_10px_rgba(0,0,0,0.05)] max-w-full border border-[#eee]" data-id="element-213">
          <img className="w-[50px] h-auto rounded-full" alt="Garantía 30 días sin riesgo" src="https://cdn.magicpatterns.com/uploads/tAquvyoWDXbvv6EBGRe2zF/Gemini_Generated_Image_sz2uksz2uksz2uks.jpg" data-id="element-214" />
          <div className="text-left" data-id="element-215">
            <h3 className="text-[15px] text-success mb-[3px] font-bold" data-id="element-216">
              Garantía de Satisfacción
            </h3>
            <p className="text-[12px] text-dark-gray m-0" data-id="element-217">
              <strong data-id="element-218">7 días</strong> para probar el plan sin ningún riesgo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}